import { Subtopic } from "./subtopic.model";

export class Topic {
  topic: string;
  subtopics: Subtopic[];
  expanded: boolean = false;
  checked: boolean = true;

  constructor(topic: string, subtopics: string[]) {
    this.topic = topic;
    this.subtopics = subtopics.map((subtopic: any) => new Subtopic(subtopic));
  }

  public static constructTopic(data: any): Topic {
    return new Topic(data.topic, data.subtopics);
  }
}